export default __webpack_public_path__ + "static/N0288-ce869f3669d75d2e12526606317ad023.png";